import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { Home, Grid3X3, Sparkles, Newspaper, User } from "lucide-react";
import { useTablet } from "../hooks/useTablet";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const TABS = [
    { path: "/app/home", icon: Home, label: t.nav.home, key: "home" },
    { path: "/app/catalog", icon: Grid3X3, label: t.nav.catalog, key: "catalog" },
    { path: "/app/tryon", icon: Sparkles, label: t.nav.tryon, key: "tryon" },
    { path: "/app/news", icon: Newspaper, label: t.nav.news, key: "news" },
    { path: "/app/profile", icon: User, label: t.nav.profile, key: "profile" },
  ];

  const { tablet } = useTablet();

  if (tablet) {
    return (
      <div className="ang-sidebar" data-testid="tablet-sidebar" style={{
        position: "fixed", top: 0, left: 0, bottom: 0, width: "116px", zIndex: 50,
        background: "var(--ang-bg-top)", borderRight: "1px solid var(--ang-border)",
        display: "flex", flexDirection: "column", alignItems: "center", gap: "6px",
        paddingTop: "26px",
      }}>
        <img src="/logo-dark.png" alt="Angiolini" data-testid="sidebar-logo"
          style={{ width: "78px", marginBottom: "22px", objectFit: "contain" }} />
        {TABS.map(({ path, icon: Icon, label, key }) => {
          const active = location.pathname === path || (path !== "/app/home" && location.pathname.startsWith(path))
            || (key === "catalog" && location.pathname.startsWith("/app/category"));
          return (
            <button key={path} onClick={() => navigate(path)} data-testid={`nav-tab-${key}`}
              style={{ width: "92px", display: "flex", flexDirection: "column", alignItems: "center", gap: "6px",
                padding: "14px 6px", background: active ? "var(--ang-gold-soft)" : "none",
                border: active ? "1px solid var(--ang-gold-line)" : "1px solid transparent",
                borderRadius: "10px", cursor: "pointer",
                color: active ? "var(--ang-gold)" : "var(--ang-text-faint)", transition: "background 0.2s, color 0.2s" }}>
              <Icon size={22} strokeWidth={active ? 2 : 1.5} />
              <span style={{ fontFamily: "Manrope", fontSize: "10px", letterSpacing: "0.05em",
                textTransform: "uppercase", textAlign: "center", lineHeight: 1.3 }}>{label}</span>
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="bottom-nav" style={{
      position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)",
      width: "100%", maxWidth: "430px", zIndex: 50,
      display: "flex", justifyContent: "space-around", alignItems: "center",
      height: "64px", paddingBottom: "env(safe-area-inset-bottom, 0)"
    }}>
      {TABS.map(({ path, icon: Icon, label, key }) => {
        const active = location.pathname === path || (path !== "/app/home" && location.pathname.startsWith(path))
            || (key === "catalog" && location.pathname.startsWith("/app/category"));
        const isAccent = key === "tryon";
        return (
          <button key={path} onClick={() => navigate(path)}
            data-testid={`nav-tab-${key}`}
            style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px",
              padding: "8px 8px", background: "none", border: "none", cursor: "pointer",
              color: active ? "var(--ang-gold)" : (isAccent ? "var(--ang-gold-strong)" : "var(--ang-text-faint)"),
              transition: "color 0.2s", flex: 1 }}>
            <Icon size={isAccent ? 22 : 20} strokeWidth={active ? 2 : 1.5} />
            <span style={{ fontFamily: "Manrope", fontSize: "9px", letterSpacing: "0.04em", textTransform: "uppercase", fontWeight: isAccent ? 600 : 400 }}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
